import { render, staticRenderFns } from "./Obstacle.vue?vue&type=template&id=42e8e9b6"
import script from "./Obstacle.vue?vue&type=script&lang=js"
export * from "./Obstacle.vue?vue&type=script&lang=js"
import style0 from "./Obstacle.vue?vue&type=style&index=0&id=42e8e9b6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports